import { createFileRoute } from "@tanstack/react-router"
import CustomHead from "~/components/SEOHead/CustomHead"
import { AdminAssetJobDetail } from "~/components/Admin/AdminAssetJobDetail"

function AssetJobDetailPage() {
  const { id } = Route.useParams()
  return (
    <>
      <CustomHead title="Asset Job Detail" />
      <div className="container mx-auto space-y-6 p-8">
        <AdminAssetJobDetail jobId={id} />
      </div>
    </>
  )
}

export const Route = createFileRoute("/admin/asset-jobs/$id")({
  component: AssetJobDetailPage,
})
